export const htmlToText = (htmlString: string) => {
  if (htmlString.length > 0) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.innerText || '';
  }
  return '';
};



 export  const getAssigneName = (assignUserDetail: any, assigneType: any) => {
    if (!assignUserDetail || !assigneType) return '';
    if (assigneType === 'USER') {
      const { firstName, lastName, email } = assignUserDetail;

      const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

      return fullName || email || '';
    }
    if (assigneType === 'TEAM') {
      return assignUserDetail.name;
    }
    return '';
  };
